import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function DashShell({ title, subtitle, nav: items, active, onNav, children }) {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/login"); };

  return (
    <div className="min-h-screen bg-surface flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static z-50 inset-y-0 left-0 w-64 bg-ink text-white transform transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-5 flex items-center justify-between">
          <div><div className="font-display font-extrabold text-xl">BiteGoFood</div><div className="text-[11px] text-white/60">{title}</div></div>
          <button className="lg:hidden" onClick={() => setOpen(false)}><X size={20} /></button>
        </div>
        <nav className="px-3 space-y-1 overflow-y-auto max-h-[calc(100vh-160px)]">
          {items.map((it) => (
            <button key={it.key} onClick={() => { onNav(it.key); setOpen(false); }} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-left tap ${active === it.key ? "bg-coral text-white" : "text-white/70 hover:bg-white/10"}`} data-testid={`dashnav-${it.key}`}>
              <it.icon size={18} /> {it.label}
            </button>
          ))}
        </nav>
        <button onClick={doLogout} className="absolute bottom-4 left-3 right-3 flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-white/70 hover:bg-white/10" data-testid="dash-logout"><LogOut size={18} /> Log out</button>
      </aside>
      {open && <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="sticky top-0 z-30 bg-white border-b border-border px-4 py-3 flex items-center gap-3">
          <button className="lg:hidden" onClick={() => setOpen(true)}><Menu size={22} /></button>
          <div className="min-w-0"><h1 className="font-display font-bold text-lg text-ink truncate">{subtitle}</h1></div>
          <div className="ml-auto flex items-center gap-2"><div className="text-right hidden sm:block"><div className="text-sm font-bold text-ink truncate max-w-[160px]">{user?.name}</div><div className="text-[11px] text-ink-600 capitalize">{user?.role}</div></div><div className="w-9 h-9 rounded-full bg-coral-light text-coral flex items-center justify-center font-bold">{user?.name?.[0] || "B"}</div></div>
        </header>
        <main className="flex-1 p-4 overflow-x-hidden">{children}</main>
      </div>
    </div>
  );
}

export function Confirm({ open, title, message, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4" onClick={onCancel}>
      <div className="bg-white rounded-2xl p-5 max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-display font-bold text-lg text-ink">{title}</h3>
        <p className="text-sm text-ink-600 mt-1">{message}</p>
        <div className="flex gap-2 mt-4"><button onClick={onCancel} className="flex-1 border border-border rounded-xl py-2.5 font-semibold text-sm">Cancel</button><button onClick={onConfirm} className="flex-1 bg-bad text-white rounded-xl py-2.5 font-semibold text-sm" data-testid="confirm-yes">Confirm</button></div>
      </div>
    </div>
  );
}
